import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";

/** B6 rest (4 nov 2026): wat NovaMund per vaste app mag, onder Jouw koppelingen.
 *
 *  HET SCHERM REKENT NIETS ZELF. De backend leest het uit de code (`services/rechten_per_app.py`):
 *  een "na jouw klik" bestaat alleen als de scope of de schrijffunctie bestaat. Hier staat alleen
 *  hoe het heet, in de taal van de app.
 */
export const HANDELING = {
  mail_lezen: "Mail lezen (afzender, onderwerp, tijd)",
  antwoord_versturen: "Een antwoord versturen",
  agenda_lezen: "De agenda lezen",
  afspraak_maken: "Een afspraak maken",
  bestanden_lezen: "Bestanden lezen",
  gesprekken_lezen: "Gesprekken en actiepunten lezen",
  taken_lezen: "Taken lezen",
  taak_maken_afvinken_verzetten: "Een taak maken, afvinken of verzetten",
};
const WANNEER = { direct: "Leest direct", na_klik: "Na jouw klik" };

export default function RechtenPerApp() {
  const { t } = useTaal();
  const [apps, setApps] = useState(null);
  useEffect(() => {
    let weg = false;
    axios.get(`${API}/mcp-servers/rechten-per-app`)
      .then((r) => { if (!weg) setApps(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (!weg) setApps([]); });
    return () => { weg = true; };
  }, []);
  if (!apps?.length) return null;
  return (
    <section className="border rounded-lg p-3 space-y-2 mt-4" data-testid="rechten-per-app">
      <h3 className="text-sm font-medium">{t("Wat NovaMund mag per app")}</h3>
      <ul className="space-y-2">
        {apps.map((app) => (
          <li key={app.bron} data-testid={`rechten-app-${app.bron}`}>
            <p className="text-sm">{app.naam}</p>
            <ul className="text-xs text-[hsl(var(--muted-foreground))]">
              {(app.mag || []).map((m) => (
                <li key={m.handeling} className="break-words">
                  {t(HANDELING[m.handeling] || m.handeling)}: {t(WANNEER[m.wanneer] || m.wanneer)}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </section>
  );
}
